export default __webpack_public_path__ + "static/media/1.888a90e3.png";